import { render, staticRenderFns } from "./no_approve.vue?vue&type=template&id=fb9048d2&scoped=true"
import script from "./no_approve.vue?vue&type=script&lang=js"
export * from "./no_approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9048d2",
  null
  
)

export default component.exports